import { sortByProperty } from '../../../../util/sort'

export const REDUCER_NAME = 'auth'

export const ERROR_PASSWORD_NOT_IDENTICAL = 'password_not_identical'
export const ERROR_PASSWORD_NOT_SECURE = 'password_not_secure'
export const ERROR_PASSWORD_MUST_BE_NEW = 'password_must_be_new'

export const ROLE_PARTNER = 'partner'
export const ROLE_PARTNER_PHYSICIAN = 'partner.physician'
export const ROLE_PARTNER_TREATMENT_PLANER = 'partner.treatment_planer'
export const ROLE_PARTNER_ALIGNER_PRODUCER = 'partner.aligner_producer'
export const ROLE_PARTNER_LOGISTICS = 'partner.logistic'
export const ROLE_PARTNER_RETAINER_PRODUCER = 'partner.retainer_producer'
export const ROLE_PARTNER_SCAN_PHYSICIAN = 'partner.scan_physician'
export const ROLE_PARTNER_PHYSICIAN_REMOTE = 'partner.physician_remote'

export const ROLE_EMPLOYEE = 'employee'
export const ROLE_EMPLOYEE_OFFICE = 'employee.office'
export const ROLE_EMPLOYEE_STORE = 'employee.store'

export const ROLE_ACCOUNTING = 'accounting'

export const ROLE_EMPLOYEE_CUSTOMER_SERVICE = 'customer_service'

export const ROLE_CUSTOMER_SERVICE_TEAM_LEAD = 'customer_service_team_lead'

export const ROLE_2ND_LEVEL_LEGAL = '2nd_level_legal'

export const ROLE_EMPLOYEE_CALL_CENTER = 'call_center'

export const ROLE_EMPLOYEE_DENTAL_TECHNICIAN = 'dental_technician'

export const ROLE_EMPLOYEE_IMPRINT_QA = 'imprint_qa'

export const ROLE_EMPLOYEE_LOGISTICS = 'logistic'

export const ROLE_PROCESS_ADMIN = 'processAdmin'

export const ROLE_EMAIL_ADMIN = 'email_admin'

export const ROLE_WIDGET_ADMIN = 'widget_admin'

export const ROLE_REPORTING = 'reporting'

export const ROLE_PROCESS_MANAGER = 'process_manager'

export const ROLE_TREATMENT_PLANER = 'treatment_planer'

export const ROLE_QM_TREATMENT_PLANNER = 'qm_treatment_planner'

export const ROLE_EMPLOYEE_TREATMENT_PRODUCER = 'treatment_producer'

export const ROLE_TREATMENT_QUOTATION_ADMIN = 'tq_admin'

export const ROLE_USER_ADMIN = 'user_admin'

export const ROLE_TASK_ADMIN = 'task_admin'

export const ROLE_MEDICAL_ADVISOR = 'medical_advisor'

export const ROLE_EMPLOYEE_SHOP_ASSISTANT = 'shop_assistant'

export const ROLE_EMPLOYEE_SHOP_PHYSICIAN = 'shop_physician'

export const ROLE_EMPLOYEE_SHOP_ZFA = 'shop_zfa'

export const ROLE_ADVISING_PHYSICIAN = 'advising_physician'

export const ROLE_TREATING_PHYSICIAN = 'treating_physician'

export const ROLE_TREATING_PHYSICIAN_REMOTE = 'treating_physician_remote'

export const ROLE_PRODUCTION_ASSISTANCE = 'production_assistance'
export const ROLE_PRODUCTION_ADMIN = 'production_admin'

export const ROLE_RETAIL_QA = 'retail_qa'

export const ROLE_CLINIC_MANAGEMENT = 'clinic_management'

export const ROLE_PRODUCTION_MARKER = 'production_marker'
export const ROLE_PRODUCTION_NESTER = 'production_nester'
export const ROLE_PRODUCTION_SORTER = 'production_sorter'
export const ROLE_PRODUCTION_THERMO_FORMER = 'production_thermo_former'
export const ROLE_PRODUCTION_LASER_MARKER = 'production_laser_marker'
export const ROLE_PRODUCTION_TRIMMER = 'production_trimmer'
export const ROLE_PRODUCTION_QM = 'production_qm'
export const ROLE_PRODUCTION_PACKER = 'production_packer'
export const ROLE_PRODUCTION_PRINTER = 'production_printer'

export const ROLE_FOIL_METADATA_ADMIN = 'foil_metadata_admin'

export const ROLE_CLINIC_SALES = 'clinic_sales';

export const ROLE_LIST_PARTNER = [
    ROLE_PARTNER,
    ROLE_PARTNER_PHYSICIAN,
    ROLE_PARTNER_TREATMENT_PLANER,
    ROLE_PARTNER_ALIGNER_PRODUCER,
    ROLE_PARTNER_RETAINER_PRODUCER,
    ROLE_PARTNER_LOGISTICS,
    ROLE_PARTNER_SCAN_PHYSICIAN,
    ROLE_PARTNER_PHYSICIAN_REMOTE,
    ROLE_CLINIC_SALES,
]

export const ROLE_LIST_EMPLOYEE = [
    ROLE_EMPLOYEE,
    ROLE_EMPLOYEE_OFFICE,
    ROLE_EMPLOYEE_STORE,
    ROLE_ACCOUNTING,
    ROLE_CUSTOMER_SERVICE_TEAM_LEAD,
    ROLE_2ND_LEVEL_LEGAL,
    ROLE_EMPLOYEE_CUSTOMER_SERVICE,
    ROLE_EMPLOYEE_CALL_CENTER,
    ROLE_EMPLOYEE_DENTAL_TECHNICIAN,
    ROLE_EMPLOYEE_IMPRINT_QA,
    ROLE_EMPLOYEE_LOGISTICS,
    ROLE_REPORTING,
    ROLE_EMAIL_ADMIN,
    ROLE_WIDGET_ADMIN,
    ROLE_TREATMENT_PLANER,
    ROLE_QM_TREATMENT_PLANNER,
    ROLE_TREATMENT_QUOTATION_ADMIN,
    ROLE_EMPLOYEE_TREATMENT_PRODUCER,
    ROLE_USER_ADMIN,
    ROLE_TASK_ADMIN,
    ROLE_EMPLOYEE_SHOP_ASSISTANT,
    ROLE_EMPLOYEE_SHOP_PHYSICIAN,
    ROLE_EMPLOYEE_SHOP_ZFA,
    ROLE_ADVISING_PHYSICIAN,
    ROLE_TREATING_PHYSICIAN,
    ROLE_TREATING_PHYSICIAN_REMOTE,
    ROLE_PRODUCTION_ASSISTANCE,
    ROLE_RETAIL_QA,
    ROLE_CLINIC_MANAGEMENT,
    ROLE_PRODUCTION_ADMIN,
    ROLE_PRODUCTION_MARKER,
    ROLE_PRODUCTION_NESTER,
    ROLE_PRODUCTION_SORTER,
    ROLE_PRODUCTION_THERMO_FORMER,
    ROLE_PRODUCTION_LASER_MARKER,
    ROLE_PRODUCTION_TRIMMER,
    ROLE_PRODUCTION_QM,
    ROLE_PRODUCTION_PACKER,
    ROLE_PRODUCTION_PRINTER,
    ROLE_MEDICAL_ADVISOR,
    ROLE_FOIL_METADATA_ADMIN,
    ROLE_CLINIC_SALES,
]

export const ROLE_LIST_EMPLOYEE_SELECT = ROLE_LIST_EMPLOYEE.map(role => ({
    id: role,
    value: role,
}))

sortByProperty(ROLE_LIST_EMPLOYEE_SELECT, 'value')

export const ROLE_LIST_PARTNER_SELECT = ROLE_LIST_PARTNER.map(role => ({
    id: role,
    value: 'Partner ' + role,
}))

sortByProperty(ROLE_LIST_PARTNER_SELECT, 'value')

export const ROLE_LIST = [...ROLE_LIST_EMPLOYEE, ...ROLE_LIST_PARTNER]

export const ROLE_LIST_SELECT = ROLE_LIST.map(role => ({
    id: role,
    value: role,
}))

sortByProperty(ROLE_LIST_SELECT, 'value')

export const STORE_BERLIN = 'berlin'
export const STORE_DORTMUND = 'dortmund'
export const STORE_DUESSELDORF = 'duesseldorf'
export const STORE_FRANKFURT = 'frankfurt'
export const STORE_HEIDELBERG = 'heidelberg'
export const STORE_HAMBURG = 'hamburg'
export const STORE_LEIPZIG = 'leipzig'
export const STORE_MUNICH = 'munich'
export const STORE_STUTTGART = 'stuttgart'

export const STORE_VIENNA = 'vienna'

export const STORE_LIST = [
    STORE_BERLIN,
    STORE_DORTMUND,
    STORE_DUESSELDORF,
    STORE_FRANKFURT,
    STORE_HAMBURG,
    STORE_HEIDELBERG,
    STORE_LEIPZIG,
    STORE_MUNICH,
    STORE_STUTTGART,
    STORE_VIENNA,
].map(store => ({
    id: store,
    value: store,
}))



// WEBPACK FOOTER //
// ./src/modules/security/state/auth/const.js